<template>
  <v-dialog
  persistent
  v-model="showDialog"
  max-width="400px"
  :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <span class="body-small" slot="activator"><u>View Email</u></span>
    <v-card :class="{'no-border': $vuetify.breakpoint.xsOnly}">
      <v-container class="modal-pad">
        <v-layout row align-center wrap mb-3>
          <v-flex xs9 style="height:30px;">
            <span class="subheading">View Email</span>
          </v-flex>
          <v-flex xs3 class="text-xs-right">
            <span class="done-button" @click="showDialog = false">done</span>
          </v-flex>
        </v-layout>
        <v-layout column pt-4>
          <v-flex>
            <p v-if="item.fromName && item.from" class="body-2">From: <span class="body-1">{{item.fromName}} - {{item.from}}</span></p>
            <v-divider></v-divider>
            <p class="body-2 pt-3">To: <span class="body-1" v-for="(email) in item.to" :key="email.id">{{email}} </span></p>
            <v-divider></v-divider>
            <p class="body-2 pt-3">Subject: <span class="body-1">{{emailSubject}}</span></p>
            <v-divider></v-divider>
            <p class="body-2 pt-3">Message</p>
            <p><span v-html="emailBody"></span></p>
            <p class="caption pt-3">Sent on {{formatDateToDateAndMins(item.created)}}</p>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDate } from '@/components/Mixins/formatDate'

export default {
  name: 'EmailView',
  props: {
    item: Object
  },
  mixins: [formatDate],
  data () {
    return {
      showDialog: false
    }
  },
  computed: {
    emailBody () {
      let str = this.item.message.replace(/(?:\r\n|\r|\n)/g, '<br>')
      str = this.replaceEmailStrings(str)
      return str
    },
    emailSubject () {
      let str = this.item.subject
      str = this.replaceEmailStrings(str)
      return str
    }
  },
  methods: {
    replaceEmailStrings (str) {
      if (this.item.invoiceTitle) {
        str = str.replace(/{{invoice-title}}/g, this.item.invoiceTitle)
      }
      if (this.item.invoice_ref) {
        str = str.replace(/{{invoice-number}}/g, this.item.invoice_ref)
      }
      if (this.item.daysOverdue) {
        str = str.replace(/{{days-overdue}}/g, this.item.daysOverdue)
      }
      if (this.item.fromName) {
        str = str.replace(/{{company-name}}/g, this.item.fromName)
      }
      return str
    }
  }
}
</script>
